<h1>Vendor Products</h1>
<nav mat-tab-nav-bar [tabPanel]="tabs">
  @for (link of links; track link) {
    <a mat-tab-link (click)="gotoTab(link.link)"
    [active]="activeLink == link">{{link.title}}</a>
  }
</nav>
@if (activeLink?.title === 'Vendor Pending Transfers') {
  <app-vendor-pending-transfers-page></app-vendor-pending-transfers-page>
}
@if (activeLink?.title === 'Vendor Completed Transfers') {
  <app-vendor-completed-transfers-page></app-vendor-completed-transfers-page>
}
<mat-tab-nav-panel #tabs></mat-tab-nav-panel>
